import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { keyframes, forwardRef, useStyleConfig, omitThemingProps, chakra, VisuallyHidden } from '@chakra-ui/react';
import { cx } from '@chakra-ui/utils';
import * as React from 'react';
var _excluded = ["label", "thickness", "speed", "emptyColor", "color", "className"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var spin = keyframes({
  '0%': {
    transform: 'rotate(0deg)'
  },
  '100%': {
    transform: 'rotate(360deg)'
  }
});

/**
 * Spinner is used to indicate the loading state of a page or a component,
 * It renders a `div` by default.
 *
 * @see Docs https://chakra-ui.com/spinner
 */
var Spinner = forwardRef(function (props, ref) {
  var styles = useStyleConfig('Spinner', props);
  var _omitThemingProps = omitThemingProps(props),
    _omitThemingProps$lab = _omitThemingProps.label,
    label = _omitThemingProps$lab === void 0 ? 'Laden...' : _omitThemingProps$lab,
    _omitThemingProps$thi = _omitThemingProps.thickness,
    thickness = _omitThemingProps$thi === void 0 ? '0.3em' : _omitThemingProps$thi,
    _omitThemingProps$spe = _omitThemingProps.speed,
    speed = _omitThemingProps$spe === void 0 ? '0.75s' : _omitThemingProps$spe,
    _omitThemingProps$emp = _omitThemingProps.emptyColor,
    emptyColor = _omitThemingProps$emp === void 0 ? 'transparent' : _omitThemingProps$emp,
    _omitThemingProps$col = _omitThemingProps.color,
    color = _omitThemingProps$col === void 0 ? 'blue.400' : _omitThemingProps$col,
    className = _omitThemingProps.className,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  var _className = cx('chakra-spinner', className);
  var spinnerStyles = _objectSpread({
    display: 'inline-block',
    borderColor: 'currentColor',
    borderStyle: 'solid',
    borderRadius: '99999px',
    borderWidth: thickness,
    borderBottomColor: emptyColor,
    borderLeftColor: emptyColor,
    color: color,
    animation: "".concat(spin, " ").concat(speed, " linear infinite")
  }, styles);
  return /*#__PURE__*/React.createElement(chakra.div, _extends({
    ref: ref,
    __css: spinnerStyles,
    className: _className
  }, rest), label && /*#__PURE__*/React.createElement(VisuallyHidden, null, label));
});
export { Spinner };